import React, { Component } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { DeclarationItems } from './DeclarationItems';
import { Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import DeclarationTable from './DeclarationTable';
import {
  applcationClear,
  apllicantData
} from '../../../redux/actions/applicantAction';
import {
  applicationIDAction,
  stopAssistance
} from '../../../redux/actions/applicationAction';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Canceletion from './CancelationDecl';
import * as api from '../../../api/api';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    // maxWidth: 360,
    backgroundColor: theme.palette.background.paper
    // marginTop: "30px"
  },
  title: {
    margin: theme.spacing(4, 0, 2)
  },
  create: {
    marginBottom: theme.spacing(0.5)
  },
  block: {
    display: 'block'
  },
  textLeft: {
    textAlign: 'left !important'
  },
  right: {
    float: 'right',
    margin: theme.spacing(2, 0, 2, 1)
  }
}));

const Declaration = props => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [docCancelApprove, setCancelApprove] = React.useState('');

  const [fileDeclaration, setFileDeclaration] = React.useState('');
  const handleStart = () => {
    // props.applcationClear();
    props.applicationIDAction(0);
    props
      .apllicantData(0)
      .then(res => {
        props.history.push('/profile-page/add');
      })
      .catch(err => {
        // props.history.push('/profile-page');
      });
    // setTimeout(() => {
    //   props.history.push('/profile-page/add');
    // }, 100);
  };

  const handleClose = () => {
    setOpen(false);
    setCancelApprove('');
  };

  const handleStop = async() => {
    // props.stopAssistance()

    try {
      console.log('stop');
      const response = await api.getCancelDocument();
      setFileDeclaration(response.data.filename);
      props.applicationIDAction(response.data.id);
      setCancelApprove('cancel');
      setOpen(true);
    } catch (error) {

    }
  };


  return (
    // <Grid container direction="row" className={classes.root}>

    <Grid
      container
      direction="row"
      justify="space-around"
      alignItems="flex-start"
      className={classes.root}
    >
      {open && (
        <Canceletion
          docCancelApprove={docCancelApprove}
          fileDeclaration={fileDeclaration}
          handleClose={handleClose}
          open={open}
          applicationIDAction={props.applicationIDAction}
        />
       )}
      <Grid item xs={12}>
        <Typography component="h2" variant="h2" className={classes.title}>
          Заяви
        </Typography>
      </Grid>

      <Grid item xs={12}>
        {/* <List> */}
        <DeclarationTable />
        {/* </List> */}
      </Grid>
      <Grid item xs={12} className={classes.create}>
        <Button
          variant="contained"
          className={classes.right}
          color="primary"
          onClick={handleStart}
          disabled={props.flag.p_showcreate === 0}
        >
          Створити заяву
        </Button>

        <Button
          variant="contained"
          className={classes.right}
          color="primary"
          onClick={handleStop}
          disabled={props.flag.p_showcancel === 0}
        >
          Припинити виплату
        </Button>
      </Grid>
      <Grid item xs={12}>
        <List className={classes.root}>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={
                <Typography
                  component="h5"
                  variant="body2"
                  color="textPrimary"
                  className={classes.textLeft}
                >
                  Натиснути на „Створити заяву” у випадку, якщо виникла потреба:
                </Typography>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    className={classes.block}
                  >
                    1. первинне створення;
                  </Typography>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    className={classes.block}
                  >
                    2. додати дитину (дітей) –в розділі „діти” додати інформацію
                    про дитину і в розділі „Документи” додати скановану копію
                    свідоцтва про народження;
                  </Typography>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    className={classes.block}
                  >
                    3. змінити банківські реквізити – в розділі „Банківські
                    реквізити” виправити номер рахунка .
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
          <Divider />
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={
                <Typography
                  component="h5"
                  variant="body2"
                  color="textPrimary"
                  className={classes.textLeft}
                >
                  Натиснути на „Припинити” у випадку, якщо виникла потреба
                  припинити виплату допомоги у зв’язку:
                </Typography>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    className={classes.block}
                  >
                    4. змінено адресу фактичного проживання;
                  </Typography>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    className={classes.block}
                  >
                    5. з інших причин.
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        </List>
      </Grid>
    </Grid>

    // </Grid>
  );
};

const mapStateToProps = state => ({
  flag: state.application.flags
});

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, {
    applcationClear,
    applicationIDAction,
    apllicantData,
    stopAssistance
  })(Declaration)
);
